import { render, staticRenderFns } from "./WirteOffList.vue?vue&type=template&id=971e0d46&scoped=true&"
import script from "./WirteOffList.vue?vue&type=script&lang=js&"
export * from "./WirteOffList.vue?vue&type=script&lang=js&"
import style0 from "./WirteOffList.vue?vue&type=style&index=0&lang=less&"
import style1 from "./WirteOffList.vue?vue&type=style&index=1&id=971e0d46&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971e0d46",
  null
  
)

export default component.exports